module.exports = __webpack_public_path__ + "assets/485d587386e8a3ea0a8efdb0b631958f.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/drop/DASS/DASS03.mp3
 ** module id = 212
 ** module chunks = 0
 **/